module.exports = __webpack_public_path__ + "img/compact.f00d6593.png";